let ghostEl;

export const GHOST_EL_ID = "ghost-element-id";

/**
 *
 * @param {React.ClipboardEvent} e
 */
const createDraggingGhost = (el, params) => {
  const { className = "dragging", wrapper } = params || {};
  const existing = document.getElementById(GHOST_EL_ID);
  if (existing) {
    document.body.removeChild(existing);
  }

  if (wrapper) {
    ghostEl = wrapper;
    ghostEl.appendChild(el.cloneNode(true));
  } else {
    ghostEl = el.cloneNode(true);
  }

  ghostEl.id = GHOST_EL_ID;
  ghostEl.classList.add(className);
  ghostEl.style.position = "absolute";
  ghostEl.style.top = "-9999px";
  ghostEl.style.left = "-9999px";
  ghostEl.style.pointerEvents = "none";

  return document.body.appendChild(ghostEl);
};

export default createDraggingGhost;
